import * as PropTypes from 'prop-types';

const StoryType = PropTypes.shape({
  category: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
});

export default StoryType;
